export const title = 'Cargo Hub Control'

export const constants = {
  DeleteText: 'Are you sure to delete this record?',
  ResetUser: 'Are you sure to reset password for this user?',
  Dashboard: 'Dashboard',
  SERVER_CONNECTION_ERROR: 'Failed to connect to server',
  NO_DATA_ERROR: 'No Flights Available',
  NO_DATA_AVAILABLE: 'No Data Available'
}

export const systemParameterTabs = {
  fleet: 'fleet',
  recovery_action: 'recovery_action',
  rebooking_teams_sla: 'rebooking_teams_sla',
  dynamic_info: 'dynamic_info',
  breakdown_work_area_mapping: 'breakdown_work_area_mapping',
  product_buildup_priority: 'product_buildup_priority',
  handling_times: 'handling_times',
  grouping: 'grouping',
  buildup_area_mapping: 'buildup_area_mapping',
  uld_mapping: 'uld_mapping',
  haulout_area_mapping: 'haulout_area_mapping',
  dod_milestones: 'dod_milestones'
}

export const pages = {
  INBOUND: 'Inbound Flight Preparation',
  inbound_flight_prep: 'Inbound Flight Preparation',
  BREAKDOWN: 'Breakdown Control',
  breakdown_control: 'Breakdown Control',
  REBOOKING: 'Rebooking Queue',
  rebooking_queue: 'Rebooking Queue',
  BUILDUP: 'Build Up Control',
  buildup_control: 'Build Up Control',
  buildup_dashboard: 'Build Up Dashboard',
  offload_dashboard: 'Offload Dashboard',
}

export const rebookingQueueTabs = {
  pending: 'Pending',
  completed: 'Completed',
  successful: 'Successful',
}

export const gatekeeperTabs = {
  processed: 'Last Processed Messages',
  search: 'Search Messages',
  performance: 'Performance info',
  audit_trail: 'Audit Trail',
}

export const changeLogTabs = {
  admin_logs: 'Admin Log',
  system_logs: 'System Log',
}

export const developerDomainTabs = {
  clear_data: 'Clear Data',
  unprocessed_msgs: 'Unprocessed Messages',
  audit: 'Audit Messages',
}

export const events = {
  FFM_OUT_RECEIVED: 'FFM',
  FFM_RECEIVED: 'FFM Received',
  FLIGHT_EVENT: 'Flight Event',
  AWB_UPDATED: 'AWB UPDATED',
  ULD_UPDATED: 'ULD UPDATE',
  BOOKING_MESSAGE: 'ECIBOOK',
  FSU: 'FSU',
  SEGMENT: 'SEGMENT',
  SYS_PARAMS: 'SYSTEM_PARAMETERS',
  RETURN: 'RETURN',
  CANCEL: 'CANCEL',
}

export const station = [
  {
    label: 'ATL',
    value: 'ATL'
  },
  {
    label: 'LAX',
    value: 'LAX'
  },
  {
    label: 'BOS',
    value: 'BOS'
  },
  {
    label: 'JFK',
    value: 'JFK'
  },
  {
    label: 'SEA',
    value: 'SEA'
  },
  {
    label: 'DTW',
    value: 'DTW'
  },
  {
    label: 'MSP',
    value: 'MSP'
  },
  {
    label: 'SLC',
    value: 'SLC'
  },
  {
    label: 'ORD',
    value: 'ORD'
  },
  {
    label: 'HNL',
    value: 'HNL'
  },
  {
    label: 'SFO',
    value: 'SFO'
  },
  {
    label: 'LHR',
    value: 'LHR'
  },
  {
    label: 'DUB',
    value: 'DUB'
  },
  {
    label: 'SNN',
    value: 'SNN'
  },
  {
    label: 'EDI',
    value: 'EDI'
  },
  {
    label: 'LGW',
    value: 'LGW'
  },
]
export const stationTime = {
  ATL: '-0500',
  LAX: '-0800',
  BOS: '-0500',
  JFK: '-0500',
  SEA: '-0800',
  DTW: '-0500',
  MSP: '-0600',
  SLC: '-0700',
  ORD: '-0600',
  HNL: '-1000',
  SFO: '-0800',
  LHR: '+0000',
  DUB: '+0000',
  SNN: '+0000',
  EDI: '+0000',
  LGW: '+0000',
}

export const timezones = {
  ATL: 'America/New_York',
  LAX: 'America/Los_Angeles',
  BOS: 'America/New_York',
  JFK: 'America/New_York',
  SEA: 'America/Los_Angeles',
  DTW: 'America/New_York',
  MSP: 'America/Chicago',
  SLC: 'America/Denver',
  ORD: 'America/Chicago',
  HNL: 'Pacific/Honolulu',
  SFO: 'America/Los_Angeles',
  LHR: 'Europe/London',
  DUB: 'Europe/Dublin',
  SNN: 'Europe/Dublin',
  EDI: 'Europe/London',
  LGW: 'Europe/London',
}

export const timezone = [
  {
    value: 'ATL',
    label: 'ATL',
    zone: 'America/New_York',
    ext: 'EST',
  },
  {
    value: 'LAX',
    label: 'LAX',
    zone: 'America/Los_Angeles',
    ext: 'PST',
  },
  {
    value: 'BOS',
    label: 'BOS',
    zone: 'America/New_York',
    ext: 'EST',
  },
  {
    value: 'JFK',
    label: 'JFK',
    zone: 'America/New_York',
    ext: 'EST',
  },
  {
    value: 'SEA',
    label: 'SEA',
    zone: 'America/Los_Angeles',
    ext: 'PST',
  },
  {
    value: 'DTW',
    label: 'DTW',
    zone: 'America/New_York',
    ext: 'EST',
  },
  {
    value: 'MSP',
    label: 'MSP',
    zone: 'America/Chicago',
    ext: 'CST',
  },
  {
    value: 'SLC',
    label: 'SLC',
    zone: 'America/Denver',
    ext: 'MST',
  },
  {
    value: 'ORD',
    label: 'ORD',
    zone: 'America/Chicago',
    ext: 'CST',
  },
  {
    value: 'HNL',
    label: 'HNL',
    zone: 'Pacific/Honolulu',
    ext: 'HST',
  },
  {
    value: 'SFO',
    label: 'SFO',
    zone: 'America/Los_Angeles',
    ext: 'PST',
  },
  {
    value: 'LHR',
    label: 'LHR',
    zone: 'Europe/London',
    ext: 'GMT',
  },
  {
    value: 'DUB',
    label: 'DUB',
    zone: 'Europe/Dublin',
    ext: 'GMT',
  },
  {
    value: 'SNN',
    label: 'SNN',
    zone: 'Europe/Dublin',
    ext: 'GMT',
  },
  {
    value: 'EDI',
    label: 'EDI',
    zone: 'Europe/London',
    ext: 'GMT',
  },
  {
    value: 'LGW',
    label: 'LGW',
    zone: 'Europe/London',
    ext: 'GMT',
  },
  
]

export const department = [
  {
    label: 'Dept1',
    value: 'Dept1'
  },
  {
    label: 'Dept2',
    value: 'Dept2'
  },
]

export const pagelist = [
  {
    key: '1',
    link: '/gatekeeper',
    title: 'Gatekeeper',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader'],
    is_menu: true
  },
  {
    key: '2',
    link: '/system-parameter',
    title: 'System Parameters',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader'],
    is_menu: true
  },
  {
    key: '3',
    link: '/notes',
    title: 'Notes',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'Re-booking Team', 'User'],
    is_menu: true
  },
  {
    key: '4',
    link: '/inbound-flight',
    title: 'Inbound Flight Preparation',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    is_menu: true
  },
  {
    key: '5',
    link: '/breakdown-control',
    title: 'Breakdown Control',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    is_menu: true
  },
  {
    key: '6',
    link: '/rebooking-queue',
    title: 'Rebooking Queue',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'Re-booking Team', 'User'],
    is_menu: true
  },
  {
    key: '7',
    link: '/manage-users',
    title: 'Manage Users',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader'],
    is_menu: true
  },
  {
    key: '8',
    link: '/dod-command-center',
    title: 'DoD Command Center',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'DOD Agent', 'Centralized DoD'],
    is_menu: true
  },
  {
    key: '9',
    link: '/buildup-control',
    title: 'Buildup Control',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    is_menu: true
  },
  {
    key: '10',
    link: '/breakdown-dashboard',
    title: 'Breakdown Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  },
  {
    key: '11',
    link: '/recovery-dashboard',
    title: 'Recovery Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  },
  {
    key: '12',
    link: '/buildup-dashboard',
    title: 'Buildup Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  },
  {
    key: '13',
    link: '/haulout-dashboard',
    title: 'Haulout Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  },
  {
    key: '14',
    link: '/reports',
    title: 'Reports',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    is_menu: true
  },
  {
    key: '15',
    link: '/tracking-awbs',
    title: 'Track and Trace AWB',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User'],
    stn: ['BOS', 'ATL'],
    is_menu: true
  },
  {
    key: '16',
    link: '/offload-dashboard',
    title: 'Offload Dashboard',
    className: 'sider-menu-item',
    roles: ['Super Admin', 'Station Leader', 'User', 'Warehouse TV'],
    is_menu: true
  }
]

export const errormsg = { sel_work_area: 'Select Work Area' }

export const jsonTheme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#0000',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
}

export const changeLogLabels = {
  //FLEET
  ac_code: 'AC Code',
  aft_conf: 'Aft Hold Config',
  key: 'Aft Hold Config Key',
  name: 'Attachment',
  path: 'Aft Hold Config Path',
  alwd_uld_type: 'Allowed ULDs',
  cont_type: 'Cont Type',
  fwd_conf: 'Fwd Hold Config',
  gen_info: 'Gen Info',
  is_loose: 'Loose',
  is_uld: 'ULD',
  pax_cap: 'Pax Cap',
  //REBOOKING TEAMS & SLA
  q_priority: 'Queue Priority',
  rebook_team: 'Rebooking Team',
  sla_time: 'SLA',
  //RECOVERY ACTION
  action: 'Recovery Action',
  email: 'Email',
  is_breakdown: 'Breakdown',
  is_buildup: 'Buildup',
  is_gen_rebook: 'Gen Rebook',
  is_inbound: 'Inbound',
  is_notify: 'Notify',
  q_to: 'Queue to',
  station_limit: 'Limit to Station',
  recovery_teams_id: 'Recovery Teams ID',
  //DYNAMIC INFO
  ac_type: 'AC Type',
  attach_conf: 'Attachment',
  contry_code: 'Country Code',
  enddate: 'End Date',
  flightno: 'Flight #',
  prod_code: 'Prod Code',
  remarks: 'Remarks',
  spl_code: 'Special Codes',
  startdate: 'Start Date',
  uld_type: 'ULD Type',
  station: 'Station',
  //PWAM
  area_name: 'Work Area Name',
  area_id: 'Area ID',
  p_code: 'Product Code',
  transfer_type: 'Transfer Type',
  location: 'Location',
  //BUP
  priority: 'Priority',
  //HANDLING TIMES
  ac_load: 'AC LOAD',
  ac_offld: 'AC OFFLD',
  at_gate: 'AT GATE',
  bd_store: 'BD & STORE',
  build_up: 'BUILD UP',
  exp_acpt: 'ACCEPT',
  fpe: 'FPE',
  mvt: 'MVT',
  process: 'PROCESS',
  tfr_to_wh: 'TFR TO WH',
  trf_to_ac: 'TFR TO AC',
  indicator_time: 'Amber Indicator',
  //COMMON
  updatedAt: 'Updated At',
  //INBOUND
  uld_dispo: 'ULD Dispo',
  deliver_to: 'Deliver To',
  //REBOOKING
  reason: 'Reason',
  status: 'Status',
  rebook_req_datetime: 'Rebooking Requested',
  rebook_comp_datetime: 'Rebooking Completed',
  rebook_undo_datetime: 'Undo Rebooking',
}

export const cut_codes = [
  {
    code: '11U Weight & Balance',
    reasons: [
      'Not Enough Payload Available',
      'Unable to Balance Aircraft',
      'Change in Flight Plan',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other',
    ],
    cutby: 'ALA'
  },
  {
    code: '12U Bulk Out',
    reasons: [
      'Needed Additional Positions for Bags',
      'Lost Space due to Positioning',
      'Unable to Fit within Bin Footprint',
      'Too Much Cargo Staged',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '13R ALA Failed to Load',
    reasons: [
      'Quick Turn/IROP',
      'No GSE Available',
      'No Staffing',
      'ALA Discretion',
      'Weather/Ramp Closed',
      'Overhang/Contour Issue',
      'Safety Concerns',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '15U Late/No Show at Gate',
    reasons: [
      'Late/No Show at Gate',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '16U Missing Label',
    reasons: [
      'Missing Labels ',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '17U Missing/Incorrect DG Info',
    reasons: [
      'Missing/Incorrect DG Info',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '18U Damaged FRT/ULD',
    reasons: [
      'Damaged FRT/ULD',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '19U Placard/RWS Discrepancy',
    reasons: [
      'Placard/RWS Discrepancy',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '20U Missing/Damaged Straps/Nets',
    reasons: [
      'Missing/Damaged Straps/Nets',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '21U Strap Point Inop',
    reasons: [
      'Strap Point Inop',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '36U Aircraft Mechanical',
    reasons: [
      'Aircraft Mechanical',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: '51C Pilot Refusal',
    reasons: [
      'Pilot Refusal',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'ALA'
  },
  {
    code: 'ALA Cut via ALIS',
    reasons: [
      'Not Enough Payload Available',
      'Unable to Balance Aircraft',
      'Needed Additional Positions for Bags',
      'Unable to Fit Within Bin Footprint',
      'Lost Space due to Positioning',
      'ALA Failed to Load',
      'No Show/Late to Gate',
      'Too Much Cargo Staged',
      'ULD Damaged',
      'Pallet Stack',
      'Wrong Equipment Used',
      'Other'
    ],
    cutby: 'LCC'
  },
  {
    code: 'LCC Cut via ALIS',
    reasons: [
      'Manually Cut by LCC Agent',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: 'OPN',
    reasons: [
      'Cargo Missed FPE',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: 'TOW',
    reasons: [
      'Planned Payload Exceeds Max Payload',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: 'WGT',
    reasons: [
      'Max Bin Weight or ULD Gross Weight Exceeded',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: 'ZFW',
    reasons: [
      'Planned Payload Exceeds Max Payload',
      'Pallet Stack',
      'Wrong Equipment Used',
    ],
    cutby: 'LCC'
  },
  {
    code: '34U Flight Cancelled',
    reasons: [
      'Pallet Stack',
      'Wrong Equipment Used',
      'N/A',
    ],
    cutby: 'N/A'
  }
]

export const audit_status = [
  {
    key: '1',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'Yes',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'zero',
    emote: 'SmileOutlined',
    color: 'green'
  },
  {
    key: '2',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'Yes',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '3',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'Yes',
    meet_wgt_goal: 'No',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '4',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'Yes',
    meet_wgt_goal: 'No',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '5',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'No',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '6',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'No',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '7',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'No',
    meet_wgt_goal: 'No',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '8',
    audit_submitted: 'Yes',
    planned_accordingly: 'Yes',
    optimal: 'No',
    meet_wgt_goal: 'No',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '9',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'Yes',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '10',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'Yes',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '11',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'Yes',
    meet_wgt_goal: 'No',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '12',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'Yes',
    meet_wgt_goal: 'No',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '13',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'No',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '14',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'No',
    meet_wgt_goal: 'Yes',
    num_of_rides: 'greater',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '15',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'No',
    meet_wgt_goal: 'No',
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '16',
    audit_submitted: 'Yes',
    planned_accordingly: 'No',
    optimal: 'No',
    meet_wgt_goal: 'No',
    num_of_rides: 'greater',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '17',
    audit_submitted: 'No',
    planned_accordingly: null,
    optimal: null,
    meet_wgt_goal: null,
    num_of_rides: 'zero',
    emote: 'MehOutlined',
    color: 'grey'
  },
  {
    key: '18',
    audit_submitted: 'No',
    planned_accordingly: null,
    optimal: null,
    meet_wgt_goal: null,
    num_of_rides: 'greater',
    emote: 'FrownOutlined',
    color: 'grey'
  },
]

export const ldd_status = [
  {
    key: '1',
    pallets_paired: 'Yes',
    pallets_paired_contact: null,
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'Yes',
    emote: 'SmileOutlined',
    color: 'green'
  },
  {
    key: '2',
    pallets_paired: 'Yes',
    pallets_paired_contact: null,
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'No',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '3',
    pallets_paired: 'Yes',
    pallets_paired_contact: null,
    conveyances_staged: 'No',
    conveyances_staged_contact: null,
    emote: 'MehOutlined',
    color: 'green'
  },
  {
    key: '4',
    pallets_paired: 'No',
    pallets_paired_contact: 'Yes',
    conveyances_staged: 'No',
    conveyances_staged_contact: null,
    emote: 'SmileOutlined',
    color: 'green'
  },
  {
    key: '5',
    pallets_paired: 'No',
    pallets_paired_contact: 'Yes',
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'No',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '6',
    pallets_paired: 'No',
    pallets_paired_contact: 'Yes',
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'Yes',
    emote: 'SmileOutlined',
    color: 'green'
  },
  {
    key: '7',
    pallets_paired: 'No',
    pallets_paired_contact: 'No',
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'Yes',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '8',
    pallets_paired: 'No',
    pallets_paired_contact: 'No',
    conveyances_staged: 'Yes',
    conveyances_staged_contact: 'No',
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '9',
    pallets_paired: 'No',
    pallets_paired_contact: 'No',
    conveyances_staged: 'No',
    conveyances_staged_contact: null,
    emote: 'FrownOutlined',
    color: 'green'
  },
  {
    key: '10',
    pallets_paired: null,
    pallets_paired_contact: null,
    conveyances_staged: 'Yes',
    conveyances_staged_contact: null,
    emote: 'MehOutlined',
    color: 'red'
  },
  {
    key: '1',
    pallets_paired: null,
    pallets_paired_contact: null,
    conveyances_staged: null,
    conveyances_staged_contact: null,
    emote: 'MehOutlined',
    color: 'grey'
  },

]

export const ch_wt_goals = [
  {
    lane: 'MSPAMS',
    kg: 520,
    lbs: 1146.4039156395
  },
  {
    lane: 'MSPCDG',
    kg: 470,
    lbs: 1036.17276990493
  },
  {
    lane: 'MSPHND',
    kg: 315,
    lbs: 694.456218127772
  },
  {
    lane: 'MSPICN',
    kg: 449,
    lbs: 989.875688696412
  },
  {
    lane: 'MSPLHR',
    kg: 413,
    lbs: 910.509263767523
  },
  {
    lane: 'MSPHNL',
    kg: 518,
    lbs: 1141.99466981011
  },
  {
    lane: 'DTWAMS',
    kg: 501,
    lbs: 1104.51608026036
  },
  {
    lane: 'DTWLHR',
    kg: 542,
    lbs: 1194.90561976271
  },
  {
    lane: 'DTWCDG',
    kg: 445,
    lbs: 981.057197037646
  },
  {
    lane: 'DTWFCO',
    kg: 585,
    lbs: 1289.70440509443
  },
  {
    lane: 'DTWFRA',
    kg: 517,
    lbs: 1139.79004689542
  },
  {
    lane: 'DTWMUC',
    kg: 448,
    lbs: 987.67106578172
  },
  {
    lane: 'DTWHND',
    kg: 525,
    lbs: 1157.42703021295
  },
  {
    lane: 'DTWICN',
    kg: 342,
    lbs: 753.981036824438
  },
  {
    lane: 'DTWPVG',
    kg: 121,
    lbs: 266.759372677652
  },
  {
    lane: 'DTWATL',
    kg: 515,
    lbs: 1135.38080106604
  },
  {
    lane: 'DTWHNL',
    kg: 328,
    lbs: 723.116316018759
  },
  {
    lane: 'SEAAMS',
    kg: 447,
    lbs: 985.466442867029
  },
  {
    lane: 'SEACDG',
    kg: 371,
    lbs: 817.915101350487
  },
  {
    lane: 'SEALHR',
    kg: 325,
    lbs: 716.502447274685
  },
  {
    lane: 'SEAHND',
    kg: 462,
    lbs: 1018.5357865874
  },
  {
    lane: 'SEAICN',
    kg: 375,
    lbs: 826.733593009252
  },
  {
    lane: 'SEAPVG',
    kg: 534,
    lbs: 1177.26863644518
  },
  {
    lane: 'BOSAMS',
    kg: 366,
    lbs: 806.89198677703
  },
  {
    lane: 'BOSCDG',
    kg: 283,
    lbs: 623.908284857649
  },
  {
    lane: 'BOSLHR',
    kg: 382,
    lbs: 842.165953412092
  },
  {
    lane: 'BOSFCO',
    kg: 75,
    lbs: 165.34671860185
  },
  {
    lane: 'BOSTLV',
    kg: 149,
    lbs: 328.48881428901
  },
  {
    lane: 'BOSDUB',
    kg: 415,
    lbs: 914.918509596906
  },
  {
    lane: 'BOSEDI',
    kg: 57,
    lbs: 125.663506137406
  },
  {
    lane: 'BOSLIS',
    kg: 143,
    lbs: 315.261076800862
  },
  {
    lane: 'BOSATH',
    kg: 61,
    lbs: 134.481997796172
  },
  {
    lane: 'LAXCDG',
    kg: 453,
    lbs: 998.694180355177
  },
  {
    lane: 'LAXLHR',
    kg: 404,
    lbs: 890.667657535301
  },
  {
    lane: 'LAXHND',
    kg: 472,
    lbs: 1040.58201573431
  },
  {
    lane: 'LAXSYD',
    kg: 971,
    lbs: 2140.68885016529
  },
  {
    lane: 'LAXATL',
    kg: 447,
    lbs: 985.466442867029
  },
  {
    lane: 'LAXJFK',
    kg: 461,
    lbs: 1016.33116367271
  },
  {
    lane: 'LAXHNL',
    kg: 489,
    lbs: 1078.06060528407
  },
  {
    lane: 'JFKAMS',
    kg: 436,
    lbs: 961.215590805424
  },
  {
    lane: 'JFKCDG',
    kg: 414,
    lbs: 912.713886682215
  },
  {
    lane: 'JFKDUB',
    kg: 416,
    lbs: 917.123132511597
  },
  {
    lane: 'JFKZRH',
    kg: 621,
    lbs: 1369.07083002332
  },
  {
    lane: 'JFKFCO',
    kg: 500,
    lbs: 1102.31145734567
  },
  {
    lane: 'JFKMXP',
    kg: 452,
    lbs: 996.489557440486
  },
  {
    lane: 'JFKBCN',
    kg: 752,
    lbs: 1657.87643184789
  },
  {
    lane: 'JFKLHR',
    kg: 435,
    lbs: 959.010967890733
  },
  {
    lane: 'JFKFRA',
    kg: 485,
    lbs: 1069.2421136253
  },
  {
    lane: 'JFKBRU',
    kg: 425,
    lbs: 936.96473874382
  },
  {
    lane: 'JFKMAD',
    kg: 473,
    lbs: 1042.786638649
  },
  {
    lane: 'JFKBOG',
    kg: 416,
    lbs: 917.123132511597
  },
  {
    lane: 'JFKGRU',
    kg: 403,
    lbs: 888.46303462061
  },
  {
    lane: 'JFKACC',
    kg: 355,
    lbs: 782.641134715426
  },
  {
    lane: 'JFKDSS',
    kg: 563,
    lbs: 1241.20270097122
  },
  {
    lane: 'JFKTLV',
    kg: 521,
    lbs: 1148.60853855419
  },
  {
    lane: 'JFKATH',
    kg: 466,
    lbs: 1027.35427824616
  },
  {
    lane: 'JFKLAX',
    kg: 1149,
    lbs: 2533.11172898035
  },
  {
    lane: 'JFKSFO',
    kg: 447,
    lbs: 985.466442867029
  },
  {
    lane: 'JFKATL',
    kg: 468,
    lbs: 1031.76352407555
  },
  {
    lane: 'GRUATL',
    kg: 531,
    lbs: 1170.6547677011
  },
  {
    lane: 'GRUJFK',
    kg: 439,
    lbs: 967.829459549498
  },
  {
    lane: 'ATLAMS',
    kg: 467,
    lbs: 1029.55890116086
  },
  {
    lane: 'ATLCDG',
    kg: 664,
    lbs: 1463.86961535505
  },
  {
    lane: 'ATLCPT',
    kg: 100,
    lbs: 220.462291469134
  },
  {
    lane: 'ATLFCO',
    kg: 515,
    lbs: 1135.38080106604
  },
  {
    lane: 'ATLFRA',
    kg: 527,
    lbs: 1161.83627604234
  },
  {
    lane: 'ATLJNB',
    kg: 213,
    lbs: 469.584680829255
  },
  {
    lane: 'ATLLHR',
    kg: 660,
    lbs: 1455.05112369628
  },
  {
    lane: 'ATLLOS',
    kg: 392,
    lbs: 864.212182559005
  },
  {
    lane: 'ATLMAD',
    kg: 430,
    lbs: 947.987853317276
  },
  {
    lane: 'ATLMUC',
    kg: 415,
    lbs: 914.918509596906
  },
  {
    lane: 'ATLHND',
    kg: 572,
    lbs: 1261.04430720345
  },
  {
    lane: 'ATLICN',
    kg: 222,
    lbs: 489.426287061477
  },
  {
    lane: 'ATLBOG',
    kg: 336,
    lbs: 740.75329933629
  },
  {
    lane: 'ATLEZE',
    kg: 560,
    lbs: 1234.58883222715
  },
  {
    lane: 'ATLGIG',
    kg: 400,
    lbs: 881.849165876536
  },
  {
    lane: 'ATLGRU',
    kg: 453,
    lbs: 998.694180355177
  },
  {
    lane: 'ATLLIM',
    kg: 480,
    lbs: 1058.21899905184
  },
  {
    lane: 'ATLSCL',
    kg: 473,
    lbs: 1042.786638649
  },
  {
    lane: 'ATLUIO',
    kg: 448,
    lbs: 987.67106578172
  },
  {
    lane: 'ATLDTW',
    kg: 388,
    lbs: 855.39369090024
  },
  {
    lane: 'ATLJFK',
    kg: 522,
    lbs: 1150.81316146888
  },
  {
    lane: 'ATLLAX',
    kg: 526,
    lbs: 1159.63165312764
  },
  {
    lane: 'ATLMSP',
    kg: 436,
    lbs: 961.215590805424
  },
  {
    lane: 'ATLSEA',
    kg: 304,
    lbs: 670.205366066167
  },
  {
    lane: 'ATLSLC',
    kg: 312,
    lbs: 687.842349383698
  },
  {
    lane: 'ATLDUB',
    kg: 589,
    lbs: 1298.5228967532
  },
  {
    lane: 'ATLPHX',
    kg: 319,
    lbs: 703.274709786537
  },
  {
    lane: 'ATLLAS',
    kg: 363,
    lbs: 800.278118032956
  },
]

export default constants